import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Observable, tap } from 'rxjs';
import * as fileSaver from 'file-saver';
import { getFileNameFromHttpResponse } from './helpers';

@Injectable()
export class PdfGeneratorService {
  constructor(private http: HttpClient) {
  }

  public generateUPOPdf(id: string): Observable<any> {
    return this.http.get(`${environment.apiBasePath}/application/${id}/upo-ezdrp`, {
      observe: 'response', responseType: 'blob'
    }).pipe(
      tap(result => {
        fileSaver.saveAs(result.body as any, getFileNameFromHttpResponse(result) || `${id}.pdf`);
      })
    );
  }

  public generateUPPPdf(id: string): Observable<any> {
    return this.http.get(`${environment.apiBasePath}/application/${id}/upp-ezdrp`, {
      observe: 'response', responseType: 'blob'
    }).pipe(
      tap(result => {
        fileSaver.saveAs(result.body as any, getFileNameFromHttpResponse(result) || `${id}.pdf`);
      })
    );
  }
}
